//---------------------------------------------------
//  Nom du fichier : callAPI.js 
//
//  Description: fonction utilisé partout pour faire un call à notre API
//               Design Pattern Facade qui normalise notre appel en une seul fonction
//               Permet de vérifier si la session n'a pas expiré, sinon reload la page et déconnecte la personne
//
//  Auteur: Alek Del Balso
//---------------------------------------------------
import { useNavigate } from 'react-router-dom';


export const callAPI = async  (request, form, islogin = undefined) => {


    let URL
    if(request == "read") URL = "https://rockstoclimb.com/Backend/AjaxFolder/AjaxRead.php"
    else if (request == "write") URL ="https://rockstoclimb.com/Backend/AjaxFolder/AjaxWrite.php"

    try {
        const response = await fetch(URL, {
            method: "POST",
            body: form,
            credentials: "include",
        });

        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

        const data = await response.json();

        if(islogin){
            localStorage.setItem("user_id", data.user_id)
            localStorage.setItem("role", data.role)
        }

        if(data.user_id != localStorage.getItem("user_id") || data.role != localStorage.getItem("role") || data.status == "LOGOUT"){ //session expired
            console.log("session expired")
            localStorage.clear();
            fetch("https://rockstoclimb.com/Backend/AjaxFolder/AjaxRead.php?logout=true", {
                method: "POST",
                credentials: "include",
            }) 
            .then(response => response.json())
            .then(data => {
                window.location.href = "/";
            })
            .catch(error => console.error("Error fetching session:", error));
        }

        return data; 
    } catch (error) {
        console.error("Error:", error);
        throw error;
    }
}
